import React from 'react';

const History_of_Numbers = () => {
    return (
        <div>History_of_Numbers Component</div>
    );
}

export default History_of_Numbers;
